import React from 'react';

export function NotFound({ onReturnHome }) {
  return (
    <div className="min-h-[80vh] flex flex-col items-center justify-center p-6 text-center space-y-6">
      <div className="text-6xl font-extrabold text-amber-400 font-mono">404</div>
      <h1 className="text-3xl font-bold text-white">Academic Route Not Found</h1>
      <p className="text-slate-400 max-w-md">
        The page or mentor profile you were looking for has moved or does not exist.
      </p>
      <button
        onClick={onReturnHome}
        className="px-6 py-3 rounded-xl bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold transition"
      >
        Return to PrepMate Academy Home
      </button>
    </div>
  );
}
